export const siteMeta = {
  siteName: "Aida Bikic",
  baseUrl: "https://aidabikic.com",
  defaultTitle: "Aida Bikic – Child Psychology, Social Media & Learning",
  defaultDescription:
    "Psychologist specialized in children's mental health, the impact of social media and technology on learning and development.",
  defaultImage: "/assets/Frontpage/Photo Frontpage.jpeg",
  twitterHandle: "@aidabikic",
  locales: ["da", "en", "de", "bs"],
};
